<template>
  <div :id="`${tableUniqueId}_main_div`">
    <div v-if="localFields && localFields.length > 0 && showTable">
      <div class="row no-margin">
        <div class="col s4 m4 l4">
          <span class="card-title">
            {{ tableTitle || "" }}
            <button v-if="showColumnFilter" class="btn-flat grey lighten-4 notification minorMargin header-buttons-left"
              :class="`${buttonThemeColor}-text`" @click="toggle = !toggle" title="View table columns by"
              id="showColumnFilterBtn">
              <!-- <span style="vertical-align:top">{{ columnFilterName }}</span> -->
              <i class="material-icons">view_week</i>
              <span class="new-count" :class="buttonThemeColor" v-if="showColumnFilterNotification">{{
                showFieldsList.length
              }}</span>
            </button>
            <slot name="headerOptionsLeft"></slot>
          </span>
          <div v-show="toggle" id="viewTableCol" class="z-depth-1">
            <label class="uppercase">
              <b>{{ columnFilterName || `View By` }}</b>
            </label>
            <label v-for="field in localFields" :key="field.key">
              <input type="checkbox" class="filled-in" :checked="showFieldsList.indexOf(field.name) >= 0"
                v-on:change="showHideField(field, $event)" />
              <span>{{ field.name }}</span>
            </label>
          </div>

        </div>
        <div class="col right-align pos-relative" :class="hideSearchBox ? 's8 m8 l8' : 's4 m4 l4'">
          <slot name="headerOptionsRight"></slot>
          <button v-if="memorizeSettingsLocally" class="btn-flat grey lighten-4 header-buttons-right"
            :class="Object.keys(getLocalSettings).length > 0 ? `${buttonThemeColor}-text` : 'grey-text'"
            title="Delete saved settings" @click="clearLocalSavedSettings()">
            <i class="material-icons">layers_clear</i>
          </button>
          <button v-if="offLineMode && showLockColumnsButton" class="btn-flat grey lighten-4 header-buttons-right"
            :class="columnLocksLocal ? `${buttonThemeColor}-text` : 'grey-text'" title="Show Column Locks"
            @click="activateDeactiveColumnLock()">
            <i class="material-icons">lock</i>
          </button>
          <button v-if="offLineMode && showColumnFilterButton" class="btn-flat grey lighten-4 header-buttons-right"
            :class="columnFiltersLocal ? `${buttonThemeColor}-text` : 'grey-text'" title="Show Column Filters"
            @click="activateDeactiveColumnFilter()">
            <i class="material-icons">filter_list</i>
          </button>
          <button v-if="offLineMode && exportExcel" class="btn-flat grey lighten-4 downloadOptions header-buttons-right"
            :class="`${buttonThemeColor}-text`" data-target='dropdown1' title="Download Excel">
            <i class="material-icons">file_download</i>
          </button>
          <!-- <a class='dropdown-trigger btn' href='#' data-target='dropdown1'>Drop Me!</a> -->

          <!-- Dropdown Structure -->
          <ul id='dropdown1' class='dropdown-content'>
            <li @click="downloadAsExcel(true)"><a>All Data</a></li>
            <li @click="downloadAsExcel()"><a>Only Filtered</a></li>
          </ul>
          <button v-if="showSearchFilter && !hideSearchBox"
            class="btn-flat grey lighten-4 notification header-buttons-right" :class="`${buttonThemeColor}-text`"
            @click="seen = !seen" title="Search by" id="showSearchFilterBtn">
            <!-- <span style="vertical-align:top">{{ searchByFilterName }}</span> -->
            <i class="material-icons">youtube_searched_for</i>
            <span class="new-count" :class="buttonThemeColor" v-if="showSearchFilterNotification">{{
              defaultSearchColumns.length
            }}</span>
          </button>
          <div v-show="seen" id="searchTable" class="z-depth-1 right0">
            <label class="uppercase">
              <b>{{ searchByFilterName || `Search By` }}</b>
            </label>
            <label v-for="field in getDisplayFieldsForSearch" :key="field.key">
              <input type="checkbox" class="filled-in" v-on:change="getSearchedData(field, $event)"
                :checked="defaultSearchColumns.indexOf(field.filterkey || field.key) >= 0" />
              <span>{{ field.name }}</span>
            </label>
          </div>
        </div>
        <div class="col s4 m4 l4 input-field right noMargin" v-if="!hideSearchBox">
          <i class="material-icons prefix">search</i>
          <input type="text" v-model="searchText" v-on:keyup="searchTextChange()" id="icon_prefix" />
          <label v-if="defaultSearchColumns.length > 0" for="icon_prefix">{{ fixedSearchBoxText
            || `Search for ${getSearchableFieldNames().join(", ")}` }}</label>
          <label v-else for="icon_prefix">{{ fixedSearchBoxText || `Search...` }}</label>
        </div>
      </div>


      <div class="col s12 mainTableWrapperDiv">
        <table class="twoColumnTable" :id="tableUniqueId">
          <tr>
            <td class="pinnedSection"
              v-if="getDisplayFieldsFixedTable.length > 0 || (actions == 'true' && (actionList && actionList.length > 0) && fixedActionColumnOnLeft)">
              <div class="tableWrap1">
                <table class="striped mainTableToRender scroll">
                  <thead>
                    <tr class="dataTableMainHeader fixedTableHeader">
                      <th class="uppercase"
                        v-if="actions == 'true' && (actionList && actionList.length > 0) && fixedActionColumnOnLeft">
                        Actions</th>
                      <th v-for="(field, i) in getDisplayFieldsFixedTable" :key="field.key" class="noMargin noPadding"
                        :class="currentDragOverIndex === field.actualIndex ? 'drag-over' : ''" :draggable="moveableColumn"
                        @dragover.prevent @dragstart="dragStart('FT', field.actualIndex)"
                        @dragenter="dragEnter('FT', field.actualIndex)" @dragend="dragEnd()"
                        @drop="move('FT', field.actualIndex)">
                        <table>
                          <tr>
                            <td class="noMargin noPadding" :class="field.sortable ? 'pointer' : ''">
                              <table class="tableHeadWithIcon">
                                <tr>
                                  <td>{{ field.name }}</td>
                                  <td><i @click.self="sort(field)" class="material-icons tiny"
                                      v-if="getSortingDetails(field)">{{
                                        getArrow(field)
                                      }}</i></td>
                                  <td><i class="material-icons tiny columnFilterOptions"
                                      :class="columnFilterValues && columnFilterValues[field.filterkey || field.key] && columnFilterValues[field.filterkey || field.key].length > 0 ? `active-filter-icon ${buttonThemeColor}` : ''"
                                      :data-target='`filterOption_${i}`'
                                      v-show="offLineMode && columnFiltersLocal && field.multiFilterOption">filter_list</i>
                                    <i class="material-icons tiny"
                                      v-show="offLineMode && columnLocksLocal && field.lockable"
                                      @click="unLockColumn(field.actualIndex)">lock</i>
                                    <ul :id='`filterOption_${i}`' class='filter-dropdown-content dropdown-content'
                                      v-show="offLineMode && columnFiltersLocal">
                                      <li v-for="uniq in getSortedData(allUniques[field.filterkey || field.key])">
                                        <label><input type="checkbox" class="filled-in"
                                            :value="uniq || field.defaultValue || defaultValue"
                                            v-model="columnFilterValues[field.filterkey || field.key]"
                                            v-on:change="columnFilterChange(field.filterkey || field.key, $event)">
                                          <span v-if="showColumnFilterCount">{{ uniq || field.defaultValue ||
                                            defaultValue }} ({{
    allUniqueCounts[field.filterkey || field.key][uniq]
  }})</span>
                                          <span v-else>{{ uniq || field.defaultValue ||
                                            defaultValue }}</span>
                                        </label>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </th>
                      <!--  <th class="uppercase" v-if="actions == 'true'">Actions</th> -->
                    </tr>

                  </thead>

                  <tbody v-if="entries && entries.length > 0 && !offLineMode && !loadingData">
                    <tr v-for="(entry, r) in entries" :key="r" :class="`row_${r}`">
                      <td v-if="actions == 'true' && (actionList && actionList.length > 0) && fixedActionColumnOnLeft">
                        <div v-for="(action, a) in actionList" :key="a" class="actionItems pointer">
                          <a :name="`table_link_${a}`" v-if="action.type == 'link'" :href="action.refAddress(entry)"
                            class="actionIcon">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"></div>
                            <i v-else class="material-icons tiny" :title="action.hoverTitle || ''">{{
                              action.getIcon(entry)
                            }}</i>
                          </a>
                          <div v-else-if="action.type == 'cb'">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"
                              @click="action.refAddress(entry)">
                            </div>
                            <i :title="action.hoverTitle || ''" v-else @click="action.refAddress(entry)"
                              class="material-icons tiny actionIcon">{{ action.getIcon(entry) }}</i>
                          </div>
                        </div>
                      </td>
                      <td v-for="data in getDisplayFieldsFixedTable" :key="data.key">
                        <!-- <div v-if="data.type && data.type == 'html'" v-html="getDisplayValue(entry, data)"></div> -->
                        <div
                          v-if="data.type && data.type == 'html' && typeof getDisplayValueHTML(entry, data) == 'string'"
                          v-html="getDisplayValueHTML(entry, data)"></div>
                        <div v-else-if="data.type && data.type == 'html'">
                          <span v-for="(content, c) in getDisplayValueHTML(entry, data)"
                            :key="`dynamic_content_${entry.key}_${c}`"
                            @click="content.onClick ? content.onClick(entry, data, content, c) : ''">
                            <div v-html="content.htmlContent"></div>
                          </span>
                        </div>
                        <div v-else>{{ getDisplayValue(entry, data) }}</div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="entries.length > 0">
                    <tr v-for="(entry, r) in getOfflineEntries(tableData.start, getPerPageValue())" :key="r"
                      :class="`row_${r}`">
                      <td v-if="actions == 'true' && (actionList && actionList.length > 0) && fixedActionColumnOnLeft">
                        <div v-for="(action, a) in actionList" :key="a" class="actionItems pointer">
                          <a :name="`table_link_${a}`" v-if="action.type == 'link'" :href="action.refAddress(entry)"
                            class="actionIcon">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"></div>
                            <i v-else class="material-icons tiny" :title="action.hoverTitle || ''">{{
                              action.getIcon(entry)
                            }}</i>
                          </a>
                          <div v-else-if="action.type == 'cb'">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"
                              @click="action.refAddress(entry)">
                            </div>
                            <i :title="action.hoverTitle || ''" v-else @click="action.refAddress(entry)"
                              class="material-icons tiny actionIcon">{{ action.getIcon(entry) }}</i>
                          </div>
                        </div>
                      </td>
                      <td v-for="data in getDisplayFieldsFixedTable" :key="data.key">
                        <!-- <div v-if="data.type && data.type == 'html'" v-html="getDisplayValue(entry, data)"></div> -->
                        <div
                          v-if="data.type && data.type == 'html' && typeof getDisplayValueHTML(entry, data) == 'string'"
                          v-html="getDisplayValueHTML(entry, data)"></div>
                        <div v-else-if="data.type && data.type == 'html'">
                          <span v-for="(content, c) in getDisplayValueHTML(entry, data)"
                            :key="`dynamic_content_${entry.key}_${c}`"
                            @click="content.onClick ? content.onClick(entry, data, content, c) : ''">
                            <div v-html="content.htmlContent"></div>
                          </span>
                        </div>
                        <div v-else>{{ getDisplayValue(entry, data) }}</div>
                      </td>
                    </tr>
                  </tbody>
                  <!-- <tbody v-else>
                    <tr>
                      <td :colspan="(getFieldLength())" class="center">
                        <h6 class="grey-text">No Data Found</h6>
                      </td>
                    </tr>
                  </tbody> -->
                </table>
              </div>
            </td>
            <td class="unPinnedSection">
              <div class="tableWrap">





















                <table class="striped mainTableToRender scroll">
                  <thead>
                    <tr class="dataTableMainHeader">
                      <th v-for="(field, i) in getDisplayFields" :key="field.key" class="noMargin noPadding"
                        :class="currentDragOverIndex === field.actualIndex ? 'drag-over' : ''" :draggable="moveableColumn"
                        @dragover.prevent @dragstart="dragStart('AT', field.actualIndex)"
                        @dragenter="dragEnter('AT', field.actualIndex)" @dragend="dragEnd()"
                        @drop="move('AT', field.actualIndex)">
                        <table>
                          <tr>
                            <td class="noMargin noPadding" :class="field.sortable ? 'pointer' : ''">
                              <table class="tableHeadWithIcon">
                                <tr>
                                  <td>{{ field.name }}</td>
                                  <td><i @click="sort(field)" class="material-icons tiny"
                                      v-if="getSortingDetails(field)">{{
                                        getArrow(field)
                                      }}</i></td>
                                  <td><i class="material-icons tiny columnFilterOptions"
                                      :class="columnFilterValues && columnFilterValues[field.filterkey || field.key] && columnFilterValues[field.filterkey || field.key].length > 0 ? `active-filter-icon ${buttonThemeColor}` : ''"
                                      :data-target='`filterOption1_${i}`'
                                      v-show="offLineMode && columnFiltersLocal && field.multiFilterOption">filter_list</i>
                                    <i class="material-icons tiny"
                                      v-show="offLineMode && columnLocksLocal && field.lockable"
                                      @click="lockColumn(field.actualIndex)">lock_outline</i>
                                    <ul :id='`filterOption1_${i}`' class='filter-dropdown-content dropdown-content'
                                      v-show="offLineMode && columnFiltersLocal">
                                      <li v-for="uniq in getSortedData(allUniques[field.filterkey || field.key])">
                                        <label><input type="checkbox" class="filled-in"
                                            :value="uniq || field.defaultValue || defaultValue"
                                            v-model="columnFilterValues[field.filterkey || field.key]"
                                            v-on:change="columnFilterChange(field.filterkey || field.key, $event)">
                                          <span v-if="showColumnFilterCount">{{ uniq || field.defaultValue ||
                                            defaultValue }} ({{
    allUniqueCounts[field.filterkey || field.key][uniq]
  }})</span>
                                          <span v-else>{{ uniq || field.defaultValue ||
                                            defaultValue }}</span>
                                        </label>
                                      </li>

                                    </ul>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>

                      </th>
                      <th class="uppercase"
                        v-if="actions == 'true' && (actionList && actionList.length > 0) && !fixedActionColumnOnLeft">
                        Actions</th>
                    </tr>

                  </thead>
                  <tbody v-if="entries && entries.length > 0 && !offLineMode && !loadingData">
                    <tr v-for="(entry, r) in entries" :key="r" :class="`row_${r}`">
                      <td v-for="data in getDisplayFields" :key="data.key">
                        <!-- <div v-if="data.type && data.type == 'html'" v-html="getDisplayValue(entry, data)"></div> -->
                        <div
                          v-if="data.type && data.type == 'html' && typeof getDisplayValueHTML(entry, data) == 'string'"
                          v-html="getDisplayValueHTML(entry, data)"></div>
                        <div v-else-if="data.type && data.type == 'html'">
                          <span v-for="(content, c) in getDisplayValueHTML(entry, data)"
                            :key="`dynamic_content_${entry.key}_${c}`"
                            @click="content.onClick ? content.onClick(entry, data, content, c) : ''">
                            <div v-html="content.htmlContent"></div>
                          </span>
                        </div>
                        <div v-else>{{ getDisplayValue(entry, data) }}</div>
                      </td>
                      <td v-if="actions == 'true' && (actionList && actionList.length > 0) && !fixedActionColumnOnLeft">
                        <div v-for="(action, a) in actionList" :key="a" class="actionItems pointer">
                          <a :name="`table_link_${a}`" v-if="action.type == 'link'" :href="action.refAddress(entry)"
                            class="actionIcon">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"></div>
                            <i v-else class="material-icons tiny" :title="action.hoverTitle || ''">{{
                              action.getIcon(entry)
                            }}</i>
                          </a>
                          <div v-else-if="action.type == 'cb'">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"
                              @click="action.refAddress(entry)"></div>
                            <i :title="action.hoverTitle || ''" v-else @click="action.refAddress(entry)"
                              class="material-icons tiny actionIcon">{{ action.getIcon(entry) }}</i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="entries.length > 0">
                    <tr v-for="(entry, r) in getOfflineEntries(tableData.start, getPerPageValue())" :key="r"
                      :class="`row_${r}`">
                      <td v-for="data in getDisplayFields" :key="data.key">
                        <!-- <div v-if="data.type && data.type == 'html'" v-html="getDisplayValue(entry, data)"></div> -->
                        <div
                          v-if="data.type && data.type == 'html' && typeof getDisplayValueHTML(entry, data) == 'string'"
                          v-html="getDisplayValueHTML(entry, data)"></div>
                        <div v-else-if="data.type && data.type == 'html'">
                          <span v-for="(content, c) in getDisplayValueHTML(entry, data)"
                            :key="`dynamic_content_${entry.key}_${c}`"
                            @click="content.onClick ? content.onClick(entry, data, content, c) : ''">
                            <div v-html="content.htmlContent"></div>
                          </span>
                        </div>
                        <div v-else>{{ getDisplayValue(entry, data) }}</div>
                      </td>
                      <td v-if="actions == 'true' && (actionList && actionList.length > 0) && !fixedActionColumnOnLeft">
                        <div v-for="(action, a) in actionList" :key="a" class="actionItems pointer">
                          <a :name="`table_link_${a}`" v-if="action.type == 'link'" :href="action.refAddress(entry)"
                            class="actionIcon">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"></div>
                            <i v-else class="material-icons tiny" :title="action.hoverTitle || ''">{{
                              action.getIcon(entry)
                            }}</i>
                          </a>
                          <div v-else-if="action.type == 'cb'">
                            <div v-if="action.html && action.html == 'true'" v-html="action.getIcon(entry)"
                              @click="action.refAddress(entry)"></div>
                            <i :title="action.hoverTitle || ''" v-else @click="action.refAddress(entry)"
                              class="material-icons tiny actionIcon">{{ action.getIcon(entry) }}</i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <!--  <tbody v-else>
                    <tr>
                      <td :colspan="(getFieldLength())" class="center">
                        <h6 class="grey-text">No Data Found</h6>
                      </td>
                    </tr>
                  </tbody> -->
                </table>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="loadingData" class="col s12 m12 l12">
        <h6 class="grey-text center"><b>Loading Data, Please wait...</b></h6>
      </div>
      <div v-else-if="!entries || entries.length == 0" class="col s12 m12 l12">
        <h6 class="grey-text center"><b>No Data Found</b></h6>
      </div>
      <div class="col s12 right-align pageNav" v-if="!noPagination">
        <div class="row no-margin">
          <div class="col s12">
            <table>
              <tr class="border-bottom-none right">
                <td>
                  <select class="browser-default tableRowViewer" v-model="tableData.recordsPerPage" v-on:change="
                    resetPerPage()">
                    <option v-for="(option) in getPerPageOptions()" :value="option.value"
                      :key="`pagination_options_${option.value}`">Show {{ option.displayText }}
                    </option>
                  </select>
                </td>
                <td>
                  <span>
                    <b>Showing {{ tableData.totalRecords == 0 ? 0 : getTable.start + 1 }} to {{ getTable.end }} of
                      {{ getTable.totalRecords }}</b>
                  </span>
                  <button class="btn-floating btn-small white btn-flat" @click="changePage('p')"
                    :disabled="tableData.start <= 0">
                    <i class="material-icons"
                      :class="tableData.start <= 0 ? 'grey-text' : `${buttonThemeColor}-text`">navigate_before</i>
                  </button>
                  <button class="btn-floating btn-small white btn-flat" @click="changePage('f')"
                    :disabled="tableData.end >= tableData.totalRecords">
                    <i class="material-icons"
                      :class="tableData.end >= tableData.totalRecords ? 'grey-text' : `${buttonThemeColor}-text`">navigate_next</i>
                  </button>
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </div>
    <div v-else>No Data Available</div>
  </div>
</template>

<script>

export default {
  computed: {
    getLocalSettings() {
      return this.localSavedSettingData;
    },
    getTable() {
      return this.tableData;
    },
    getCurrentSort() {
      return this.defaultSort;
    },
    getCurrentSortDir() {
      return this.defaultSortDir;
    },
    getDisplayFields() {
      let displayFields = [];
      this.localFields.map(
        (data, i) => {
          if (this.showFieldsList.indexOf(data.name) >= 0 && !data.lock) {
            data.actualIndex = i;
            displayFields.push(data);
          }
        }
      );
      return displayFields;
    },
    getDisplayFieldsFixedTable() {
      let displayFields = [];
      this.localFields.map(
        (data, i) => {
          if (this.showFieldsList.indexOf(data.name) >= 0 && data.lock) {
            data.actualIndex = i;
            displayFields.push(data);
          }
        }
      );
      return displayFields;
    },
    getDisplayFieldsForSearch() {
      let displayFields = this.localFields.filter(
        data =>
          this.showFieldsList.indexOf(data.name) >= 0 &&
          data.filterable != false
      );
      return displayFields;
    }
  },
  mounted() {
    if (!this.memorizeSettingsLocally) {
      this.clearLocalSavedSettings();
    } else {
      this.initTable();
    }
  },
  props: {
    fields: {
      type: Array,
      validator(value) {
        let validationSuccess = true;
        if (value && value.length > 0) {
          value.map(data => {
            if (data.lockable) {
              if ([true, false].indexOf(data.lock) == -1) {
                console.error(`Missing property "lock: true/false" when lockable is true for entry: ${data.name}`);
                validationSuccess = false;
              }
            }
          })
        }
        return validationSuccess;
      }
    },
    perPageOptions: Array,
    actionList: Array,
    loadEntries: Function,
    loadOfflineEntries: Function,
    defaultSort: String,
    defaultSearchColumns: {
      type: Array,
      default: () => []
    },
    defaultSortDir: String,
    tableUniqueId: {
      type: String,
      validator(value) {
        if (value.toString().indexOf(" ") == -1) {
          return true;
        } else {
          console.error(`tableUniqueId should not contain any white spaces.`);
          return false;
        }
      }
    },
    tableTitle: String,
    actions: String,
    search: Boolean,
    hideSearchBox: Boolean,
    showColumnFilter: Boolean,
    columnFilterName: String,
    showColumnFilterNotification: Boolean,
    showSearchFilter: Boolean,
    searchByFilterName: String,
    showSearchFilterNotification: Boolean,
    offLineMode: Boolean,
    columnFilters: Boolean,
    showColumnFilterCount: Boolean,
    exportExcel: Boolean,
    moveableColumn: Boolean,
    showColumnFilterButton: Boolean,
    showLockColumnsButton: Boolean,
    fixedActionColumnOnLeft: Boolean,
    memorizeSettingsLocally: Boolean,
    noPagination: Boolean,
    fixedSearchBoxText: String,
    defaultValue: {
      type: String,
      default: ''
    },
    multiFilterCondition: {
      type: String,
      default: 'AND'
    },
    buttonThemeColor: {
      type: String,
      default: 'teal'
    },
    addAllOptionInPagination: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    copyItArray(from) {
      let newArray = []
      from.map(singleItem => {
        newArray.push(this.copyIt(singleItem))
      })
      return newArray;
    },
    copyIt(from) {
      var normalFields = JSON.parse(JSON.stringify(from));
      var allKeys = Object.keys(from);
      allKeys.map(singleKey => {
        if (typeof from[singleKey] == 'function') {
          normalFields[singleKey] = from[singleKey];
        }
      });
      return normalFields;
    },
    getPerPageValue() {
      return this.getTable.recordsPerPage == "All" ? this.getTable.totalRecords : this.getTable.recordsPerPage;
    },
    updateLocalStorageData(id, key, newValue) {
      if (this.memorizeSettingsLocally) {
        delete this.localSavedSettingData[key];
        this.localSavedSettingData[key] = newValue;
        //console.log(this.localSavedSettingData);
        localStorage.setItem(`local_settings_${id}`, JSON.stringify(this.localSavedSettingData));
      }
    },
    unLockColumn(index) {
      // this.showTable = false;
      this.localFields[index].lock = false;
      this.updateLocalStorageData(this.tableUniqueId, "fields", this.localFields);
      setTimeout(() => {
        //  this.showTable = true;
        //this.$forceUpdate();
        this.resetTableSize();
        $(`.downloadOptions`).dropdown();
        $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
      }, 5);
    },
    lockColumn(index) {
      // this.showTable = false;
      //console.log("lockColumn", index);
      this.localFields[index].lock = true;
      this.updateLocalStorageData(this.tableUniqueId, "fields", this.localFields);
      setTimeout(() => {
        // this.showTable = true;
        // this.$forceUpdate();
        this.resetTableSize();
        $(`.downloadOptions`).dropdown();
        $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
      }, 5)
    },
    activateDeactiveColumnFilter() {
      this.columnLocksLocal = false;
      this.columnFiltersLocal = !this.columnFiltersLocal;
      setTimeout(() => {
        this.resetTableSize();
      }, 5)
    },
    activateDeactiveColumnLock() {
      this.columnFiltersLocal = false;
      this.columnLocksLocal = !this.columnLocksLocal;
      setTimeout(() => {
        this.resetTableSize();
      }, 5)
    },
    clearLocalSavedSettings() {
      localStorage.removeItem(`local_settings_${this.tableUniqueId}`);
      this.localSavedSettingData = {};
      this.initTable(true);
    },
    async downloadAsExcel(allData) {
      const link = document.createElement('a');
      link.setAttribute('href', `data:text/csv;charset=utf-8,${encodeURIComponent(await this.convertToCSVFormat(allData))}`);
      link.setAttribute('download', this.tableUniqueId);

      link.style.display = 'none';
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    },
    getStringifiedValue(rawString) {
      if (rawString) {
        return JSON.stringify(rawString);
      } else {
        return rawString;
      }
    },
    arrangeFieldOrder(fields) {
      let finalOrder = [];
      return new Promise((resolve, reject) => {
        fields.map((singleField, i) => {
          if (singleField.lock) {
            finalOrder.push(singleField);
          }
          if (i == fields.length - 1) {
            fields.map((singleField, j) => {
              if (!singleField.lock) {
                finalOrder.push(singleField);
              }
              if (j == fields.length - 1) {
                resolve(finalOrder);
              }
            })
          }
        })
      })
    },
    async convertToCSVFormat(allData) {
      let text = "";
      let downloadableRows;
      if (allData) {
        downloadableRows = await this.arrangeFieldOrder(this.localFields);
      } else {
        downloadableRows = this.getDisplayFieldsFixedTable.concat(this.getDisplayFields)
      }
      downloadableRows.map((field, i) => {
        if (!(field.downloadable === false)) {
          let headerValueRaw = this.capitalizeFirstLetter(field.name);
          let headerValue = headerValueRaw ? JSON.stringify(headerValueRaw) : headerValueRaw;
          if (i == 0) {
            text += `${headerValue}`;
          } else {
            if (i == downloadableRows.length - 1) {
              text += `,${headerValue}\n`;
            } else {
              text += `,${headerValue}`;
            }
          }
        } else {
          if (i == downloadableRows.length - 1) {
            text += `\n`;
          }
        }
        /*  if (i == downloadableRows.length - 1) {
           text += `${this.capitalizeFirstLetter(field.name)}\n`;
         } else {
           text += `${this.capitalizeFirstLetter(field.name)},`;
         } */
      })
      let downloadableEntries = allData ? this.offlineEntries : this.entries;
      downloadableEntries.map((row, y) => {
        downloadableRows.map((field, i) => {
          if (!(field.downloadable === false)) {
            let key = field.key;
            let key2 = `${field.key}_original`;
            if (i == 0) {
              text += field.preProcessDownload ? this.getStringifiedValue(field.preProcessDownload(Function('row', `return row.${key}`)(row), row, Function('row', `return row.${key2}`)(row))) : this.getStringifiedValue(Function('row', `return row.${key}`)(row));
            } else {
              text += field.preProcessDownload ? `,${this.getStringifiedValue(field.preProcessDownload(Function('row', `return row.${key}`)(row), row, Function('row', `return row.${key2}`)(row)))}` : `,${this.getStringifiedValue(Function('row', `return row.${key}`)(row))}`;
              /* text += `,${Function('row',`return row.${field.key}`)(row)}`; */
            }
          }
          /* if (i == downloadableRows.length - 1) {
            text += Function('row',`return row.${field.key}`)(row);
          } else {
            text += `${Function('row',`return row.${field.key}`)(row)},`;
          } */
        })
        if (y < downloadableEntries.length - 1) {
          text += `\n`;
        }
      })
      return text;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    },
    dragEnter(type, index) {
      if (type == this.currentDraggingTable) {
        if (this.currentDraggingToIndex !== this.currentDraggingFromIndex) {
          this.currentDragOverIndex = index;
        } else {
          this.currentDragOverIndex = "";
        }
      } else {
        this.currentDragOverIndex = "";
      }
    },
    /*dragLeave(fromIndex) {
      console.log("dragLeave", fromIndex)
    }, */
    dragEnd() {
      this.currentDraggingTable = "";
      this.currentDraggingToIndex = "";
      this.currentDraggingFromIndex = "";
      this.currentDragOverIndex = "";
    },
    dragStart(tableType, fromIndex) {

      // FT = Fixed Table
      // AT = Another Table
      this.currentDraggingFromIndex = fromIndex;
      this.currentDraggingTable = tableType;
    },
    move(type, toIndex) {
      this.currentDraggingToIndex = toIndex;
      if (type == this.currentDraggingTable && (this.currentDraggingToIndex !== this.currentDraggingFromIndex)) {
        let fromIndex = this.currentDraggingFromIndex;
        let toIndex = this.currentDraggingToIndex;

        let element = this.localFields.splice(fromIndex, 1)[0];
        this.localFields.splice(toIndex, 0, element);
      } else {
        this.currentDraggingTable = "";
        this.currentDraggingToIndex = "";
        this.currentDraggingFromIndex = "";
        this.currentDragOverIndex = "";
      }
      this.updateLocalStorageData(this.tableUniqueId, "fields", this.localFields);
    },
    getSortedData(array) {
      if (array) {
        if (typeof array[0] == 'number') {
          return array.sort((a, b) => a - b);
        } else {
          return array.sort();
        }
      } else {
        return [];
      }
    },
    createCopyOfEntries(entries) {
      let copyEntries = [];
      if (entries && entries.length > 0) {
        entries.map(singleItem => {
          let allKeys = Object.keys(singleItem);
          let temp = {};
          allKeys.map(data => {
            if (singleItem[data] != null) {
              if (Array.isArray(singleItem[data])) {
                temp[data] = this.copyItArray(singleItem[data]);
              } else if (typeof singleItem[data] == 'object') {
                temp[data] = JSON.parse(JSON.stringify(singleItem[data]));
              } else {
                temp[data] = singleItem[data];
              }
            } else {
              temp[data] = singleItem[data];
            }
          })
          copyEntries.push(temp);
        })
        return copyEntries;
      } else {
        return copyEntries;
      }
    },
    columnFilterChange(key) { //only runs in offline mode
      this.searchText = "";
      setTimeout(() => {
        M.updateTextFields();
      }, 5);
      if (this.columnFilterValues[key].length == 0) {
        this.activeColumnFilter -= 1;
      } else if (this.columnFilterValues[key].length == 1) {
        this.activeColumnFilter += 1;
      }

      if (this.multiFilterCondition == 'AND') {
        /* below is the AND condition */
        let temp = this.createCopyOfEntries(this.offlineEntries);
        this.localFields.map((field, i) => {

          if (field.multiFilterOption && this.columnFilterValues[field.filterkey || field.key].length > 0) {
            temp = temp.filter(row => {
              let valueOfData = Function('row', `return row.${field.filterkey || field.key}`)(row);
              if (valueOfData == undefined || valueOfData == "" || valueOfData == null || !valueOfData) {
                valueOfData = field.defaultValue || this.defaultValue;
              }
              return this.columnFilterValues[field.filterkey || field.key].indexOf(valueOfData) >= 0
            });
          }
        })
        this.entries = temp;
        this.tempOfflineColumnFilteredEntries = temp;
        this.resetPerPage();
        this.updateTableParamsOffline({ msg: this.entries });
        this.resetTableSize();
      } else {
        /* below is OR condition */
        let temp = [];
        this.offlineEntries.map(row => {
          let foundAtleastInOne = false;
          this.localFields.map((field) => {
            let valueOfData = Function('row', `return row.${field.filterkey || field.key}`)(row);
            if (valueOfData == undefined || valueOfData == "" || valueOfData == null || !valueOfData) {
              valueOfData = field.defaultValue || this.defaultValue;
            }
            if (field.multiFilterOption && this.columnFilterValues[field.filterkey || field.key].length > 0) {
              if (this.columnFilterValues[field.filterkey || field.key].indexOf(valueOfData) >= 0) {
                foundAtleastInOne = true;
              }
            }
          });
          if (foundAtleastInOne) {
            temp.push(row);
          }
        })
        this.entries = temp.length > 0 ? temp : this.createCopyOfEntries(this.offlineEntries);
        this.tempOfflineColumnFilteredEntries = temp.length > 0 ? temp : this.createCopyOfEntries(this.offlineEntries);
        this.resetPerPage();
        this.updateTableParamsOffline({ msg: this.entries });
        this.resetTableSize();
      }

      /* this.entries = this.offlineSearch(this.searchText, this.defaultSearchColumns);
       */
    },
    generateUnique() {
      let allKeys = [];
      let keysDefaultValue = {};
      this.localFields.map(field => {
        allKeys.push(field.filterkey || field.key);
        keysDefaultValue[field.filterkey || field.key] = field.defaultValue || this.defaultValue;
        this.allUniques[field.filterkey || field.key] = [];
        this.columnFilterValues[field.filterkey || field.key] = [];
        this.allUniqueCounts[field.filterkey || field.key] = {};
      })
      /* eslint-ignore-next */
      this.entries.map(singleRow => {
        allKeys.map(key => {
          let valueOfData = Function('singleRow', `return singleRow.${key}`)(singleRow);
          if (valueOfData == undefined || valueOfData == "" || valueOfData == null || !valueOfData) {
            valueOfData = keysDefaultValue[key].defaultValue;
          }
          if (this.allUniques[key].indexOf(valueOfData) == -1) {
            this.allUniques[key].push(valueOfData);
            this.allUniqueCounts[key][valueOfData] = 1;
          } else {
            this.allUniqueCounts[key][valueOfData] += 1;
          }
        })
      });
      setTimeout(() => {
        $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
      }, 5)
    },
    getSearchableFieldNames() {
      let allNames = [];
      let exceeded = false;
      let totalCount = 0;
      let selectedCount = 0;
      this.getDisplayFieldsFixedTable.concat(this.getDisplayFields).map((data) => {
        if (
          this.defaultSearchColumns.indexOf(data.filterkey || data.key) >= 0
        ) {
          totalCount += 1;
          let text = allNames.toString();
          if (text.length >= 15 || ((text + data.name).length) >= 15) {
            exceeded = true;
          } else {
            selectedCount += 1;
            allNames.push(data.name);
          }

        }
      });
      if (exceeded) {
        allNames.push(`+${totalCount - selectedCount} more`);
      }
      return allNames;
    },
    getSearchedData(_field, event) {
      if (event.target.checked) {
        this.defaultSearchColumns.push(_field.filterkey || _field.key);
        this.searchText ? this.searchTextChange() : "";
      } else {
        let index = this.defaultSearchColumns.indexOf(
          _field.filterkey || _field.key
        );
        this.defaultSearchColumns.splice(index, 1);
        this.searchText ? this.searchTextChange() : "";
      }
    },
    showHideField(_field, event) {
      if (event.target.checked) {
        this.showFieldsList.push(_field.name);
        if (_field.filterable != false) {
          this.defaultSearchColumns.push(_field.filterkey || _field.key);
          this.searchText ? this.searchTextChange() : "";
        }
        this.updateLocalStorageData(this.tableUniqueId, "visible_fields", this.showFieldsList);
        setTimeout(() => {
          $('select').formSelect();
          $(`.downloadOptions`).dropdown();
          $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
        }, 5)
        this.resetTableSize();
      } else {
        let index = this.showFieldsList.indexOf(_field.name);
        let index2 = this.defaultSearchColumns.indexOf(
          _field.filterkey || _field.key
        );
        if (index2 >= 0) {
          this.defaultSearchColumns.splice(index2, 1);
          this.searchText ? this.searchTextChange() : "";
        }
        this.showFieldsList.splice(index, 1);
        this.updateLocalStorageData(this.tableUniqueId, "visible_fields", this.showFieldsList);
        this.resetTableSize();
        $(`.downloadOptions`).dropdown();
        $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
      }
    },
    getPerPageOptions() {
      if (this.perPageOptions && this.perPageOptions.length > 0) {
        let newArray = [];
        let defaultAdded = false;
        this.perPageOptions.map((singleData, i) => {
          if (typeof singleData == "object") {
            if (singleData.defaultSelected) {
              if (defaultAdded) {
                singleData.defaultSelected = false;
                newArray.push(singleData);
              } else {
                this.paginationDefaultIndex = i;
                defaultAdded = true;
                newArray.push(singleData);
              }
            } else {
              singleData.defaultSelected = false;
              newArray.push(singleData);
            }
          } else {
            let singleObj = {
              displayText: singleData,
              value: singleData,
              defaultSelected: false
            }
            newArray.push(singleObj);
          }
          if (i == this.perPageOptions.length - 1) {
            if (!defaultAdded) {
              newArray[0].defaultSelected = true;
            }
            if (this.addAllOptionInPagination) {
              let singleObj = {
                displayText: 'All',
                value: 'All',
                defaultSelected: false
              }
              newArray.push(singleObj);
            }
          }
        })
        return newArray;
      } else {
        let newArray = [{
          displayText: 3,
          value: 3,
          defaultSelected: true
        }, {
          displayText: 5,
          value: 5,
          defaultSelected: false
        }, {
          displayText: 10,
          value: 10,
          defaultSelected: false
        }, {
          displayText: 15,
          value: 15,
          defaultSelected: false
        }, {
          displayText: 20,
          value: 20,
          defaultSelected: false
        }, {
          displayText: 30,
          value: 30,
          defaultSelected: false
        }];
        if (this.addAllOptionInPagination) {
          let singleObj = {
            displayText: 'All',
            value: this.getTable.totalRecords,
            defaultSelected: false
          }
          newArray.push(singleObj);
        }
        return newArray;
      }
    },
    getDisplayValue(entry, data) {
      let key = data.key;
      let value = data.defaultValue || this.defaultValue;
      try {
        value = Function('entry', `return entry.${key}`)(entry) || data.defaultValue || this.defaultValue;
        if (data.preProcess && !this.offLineMode) {
          return data.preProcess(value, entry);
        } else {
          return value;
        }
        // return value;
      } catch (e) {
        return value;
      }
    },
    getDisplayValueHTML(entry, data) {
      let key = data.key;
      let value = data.defaultValue || this.defaultValue;
      try {
        value = Function('entry', `return entry.${key}`)(entry) || data.defaultValue || this.defaultValue;
        if (data.preProcess && !this.offLineMode) {
          return data.preProcess(value, entry);
        } else {
          return value;
        }
        //return value;
      } catch (e) {
        return value;
      }
    },
    getFieldLength() {
      let extraColumn = 1;
      return this.actions == "true"
        ? this.localFields.length + extraColumn
        : this.localFields.length;
    },
    changePage(direction) {
      if (direction == "f") {
        this.tableData.start += this.getPerPageValue();
        this.loadEvents();
        this.resetTableSize();
      } else {
        this.tableData.start -= this.getPerPageValue();
        this.loadEvents();
        this.resetTableSize();
      }
    },
    updateTableParams(result) {
      this.tableData.totalRecords = result.count;
      this.tableData.end = this.getTable.start + this.getPerPageValue();
      if (this.tableData.end > this.tableData.totalRecords) {
        if (this.tableData.totalRecords >= 0) {
          this.tableData.end = this.tableData.totalRecords;
        } else {
          this.tableData.end = 0;
          this.tableData.totalRecords = 0;
        }
      }
    },
    updateTableParamsOffline(result) {
      this.tableData.totalRecords = result && result.msg ? result.msg.length : 0;
      this.tableData.end = this.getTable.start + this.getPerPageValue();
      if (this.tableData.end > this.tableData.totalRecords) {
        if (this.tableData.totalRecords >= 0) {
          this.tableData.end = this.tableData.totalRecords;
        } else {
          this.tableData.end = 0;
          this.tableData.totalRecords = 0;
        }
      }
    },
    resetPerPage() {
      if (this.offLineMode) {
        this.tableData.start = 0;
        this.updateTableParamsOffline({ msg: this.entries });
        this.resetTableSize();
      } else {
        this.tableData.start = 0;
        this.loadEvents();
      }
      this.updateLocalStorageData(this.tableUniqueId, "recordsPerPage", this.getTable.recordsPerPage);
    },
    getOfflineEntries(start, records) {
      return this.entries.slice(start, start + records);
    },
    loadEvents(hideLoading = false) {
      this.loadingData = true;
      if (this.offLineMode) {
        if (!this.entries || this.entries.length == 0) {
          this.loadOfflineEntries(
            result => {
              if (result.status == 200) {
                if (result.msg.length > 0) {
                  this.entries = [];
                  this.offlineEntries = [];
                  //console.log("loading....");
                  result.msg.map(singleEntry => {
                    this.fields.map(field => {
                      if (field.preProcess) {
                        singleEntry[`${field.key}_original`] = singleEntry[field.key] || field.defaultValue || this.defaultValue;
                        singleEntry[field.key] = field.preProcess(singleEntry[field.key], singleEntry) || field.defaultValue || this.defaultValue;
                      } else {
                        singleEntry[field.key] = singleEntry[field.key] || field.defaultValue || this.defaultValue;
                      }

                    })
                    this.entries.push(singleEntry);
                    this.offlineEntries.push(singleEntry);
                  })
                  //console.log("done....");
                  /* this.entries = result.msg;
                  this.offlineEntries = result.msg; */
                  this.changeOfflineSorting();
                  this.generateUnique();
                  //this.updateTableParamsOffline(result);
                  this.loadingData = false;
                  setTimeout(() => {
                    this.resetTableSize();
                  }, 5)
                } else {
                  this.entries = result.msg;
                  this.offlineEntries = result.msg;
                  this.changeOfflineSorting();
                  this.generateUnique();
                  this.loadingData = false;
                  setTimeout(() => {
                    this.resetTableSize();
                  }, 5)
                }
              } else {
                this.loadingData = false;
                setTimeout(() => {
                  this.resetTableSize();
                }, 5)
                alert(result.msg);
              }
            }
          );
        } else {
          this.updateTableParamsOffline({ msg: this.entries });
          this.loadingData = false;
        }
      } else {
        this.loadEntries(
          this.tableData.start,
          this.tableData.recordsPerPage,
          this.currentSort,
          this.currentSortDir,
          this.searchText,
          this.defaultSearchColumns,
          hideLoading,
          result => {
            this.updateTableParams(result);
            if (result.status == 200) {
              this.entries = result.msg;
              //this.generateUnique();
              this.loadingData = false;
              setTimeout(() => {
                this.resetTableSize();
              }, 5)
            } else {
              this.loadingData = false;
              setTimeout(() => {
                this.resetTableSize();
              }, 5)
              alert(result.msg); //window.location = "/";

              //window.location = "/";
            }
          }
        );
      }
    },
    getSortingDetails(field) {
      return field.sortable == true;
    },
    getArrow(field) {
      if (
        this.currentSort &&
        this.currentSort == (field.sortkey || field.key)
      ) {
        return this.currentSortDir == "asc" ? "arrow_upward" : "arrow_downward";
      } else {
        return "sort";
      }
    },
    sort(field) {
      if (field.sortable) {
        let s = field.sortkey || field.key;
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        }
        this.currentSort = s;
        this.tableData.start = 0;

        this.offLineMode ? this.changeOfflineSorting() : this.loadEvents();
        this.updateLocalStorageData(this.tableUniqueId, "currentSortDir", this.currentSortDir);
        this.updateLocalStorageData(this.tableUniqueId, "currentSort", this.currentSort);
        setTimeout(() => {
          this.resetTableSize();
        }, 5)
      }
    },
    searchTextChange() {
      if (this.timeOut) clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.tableData.start = 0;
        if (this.offLineMode) {
          if (this.activeColumnFilter > 0) {
            //this.entries = JSON.parse(JSON.stringify(this.tempOfflineColumnFilteredEntries));
            this.entries = this.createCopyOfEntries(this.tempOfflineColumnFilteredEntries);
          } else {
            //this.entries = JSON.parse(JSON.stringify(this.offlineEntries));
            this.entries = this.createCopyOfEntries(this.offlineEntries);
          }
          this.entries = this.offlineSearch(this.searchText, this.defaultSearchColumns);
          setTimeout(() => {
            this.updateTableParamsOffline({ msg: this.entries });
            this.resetTableSize();
          }, 10);
        } else {
          this.loadEvents(true);
          this.resetTableSize();
        }

      }, 200);
    },
    changeOfflineSorting() {
      /* eslint-disable-next-line */
      this.entries = this.entries.sort((a, b) => {
        var x = Function('a', `return a.${this.currentSort}`)(a);
        var y = Function('b', `return b.${this.currentSort}`)(b);
        if (this.currentSortDir === "asc") {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else {
          return ((y < x) ? -1 : ((y > x) ? 1 : 0));
        }
      });
      this.updateTableParamsOffline({ msg: this.entries });
    },
    offlineSearch(search, keys) {
      var lowSearch = search.toLowerCase();
      return this.entries.filter(wine =>
        keys.some(key =>
          String(wine[key]).toLowerCase().includes(lowSearch)
        )
      );
    },
    resetTableSize() {
      if (this.timeOutResize) clearTimeout(this.timeOutResize);
      this.timeOutResize = setTimeout(() => {
        this.setTableLayout();
        this.setRowSize();

        setTimeout(() => {
          this.setTableLayout();
          this.setRowSize();
        }, 100);
      }, 5);
    },
    setTableLayout() {

      let table1Width = $(`#${this.tableUniqueId}`).find(`.tableWrap1 table`).width() || 0;
      let table2Width = $(`#${this.tableUniqueId}`).find(`.tableWrap table`).width();
      let totalWidth = $(`#${this.tableUniqueId}_main_div`).find(`.mainTableWrapperDiv`).width();
      let element1 = $(`#${this.tableUniqueId}`).find(`.unPinnedSection .tableWrap`);
      //console.log(element1);
      let rightTableScroll = 17;
      if (element1 && element1[0]) {
        rightTableScroll = element1[0].offsetHeight - element1[0].clientHeight;
      }
      /*  let element2 = $(".pinnedSection .tableWrap1");
       let leftTableScroll = element2[0].offsetHeight - element2[0].clientHeight; */
      /* let newPercentage = table1Width / totalWidth * 100; */
      if (parseInt(table1Width + table2Width) > parseInt(totalWidth)) {
        //console.log("coming here 1.....", (table1Width + table2Width) - (totalWidth));
        $(`#${this.tableUniqueId}`).find(`.tableWrap`).css("width", `${totalWidth - table1Width - 1}px`);
        if (($(`#${this.tableUniqueId}`).find(`.tableWrap`).width() < $(`#${this.tableUniqueId}`).find(`.tableWrap table`).width()) && table1Width) {
          if ($(`#${this.tableUniqueId}`).find(`.tableWrap1`).width() >= $(`#${this.tableUniqueId}`).find(`.tableWrap1 table`).width()) {
            //$(".tableWrap1").addClass("shiftScrollTop");
            $(`#${this.tableUniqueId}`).find(`.tableWrap1`).css("margin-top", `-${rightTableScroll}px`);
          }
        } else {
          //$(".tableWrap1").removeClass("shiftScrollTop");
          $(`#${this.tableUniqueId}`).find(`.tableWrap1`).css("margin-top", `0px`);
        }
        if (table1Width) {
          $(`#${this.tableUniqueId}`).find(`.fixedTableHeader`).addClass("fixedTableHeaderColor");
        }
      } else {
        //console.log("coming here.....", (table1Width + table2Width) - (totalWidth));
        $(`#${this.tableUniqueId}`).find(`.tableWrap`).css("width", `auto`);
        if (table1Width) {
          $(`#${this.tableUniqueId}`).find(`.tableWrap1`).css("width", `auto`);
          //$(".tableWrap1").removeClass("shiftScrollTop");
          $(`#${this.tableUniqueId}`).find(`.tableWrap1`).css("margin-top", `0px`);
        }
        $(`#${this.tableUniqueId}`).find(`.fixedTableHeader`).removeClass("fixedTableHeaderColor");
      }
    },
    setRowSize() {
      setTimeout(() => {
        for (let i = 0; i < this.getPerPageValue(); i++) {
          $(`#${this.tableUniqueId}`).find(`.tableWrap .row_${i}`).height(`0px`);
          $(`#${this.tableUniqueId}`).find(`.tableWrap1 .row_${i}`).height(`0px`);
          let maxHeight = $(`#${this.tableUniqueId}`).find(`.tableWrap1 .row_${i}`).height() < $(`#${this.tableUniqueId}`).find(`.tableWrap .row_${i}`).height() ? $(`#${this.tableUniqueId}`).find(`.tableWrap .row_${i}`).height() : $(`#${this.tableUniqueId}`).find(`.tableWrap1 .row_${i}`).height();
          $(`#${this.tableUniqueId}`).find(`.tableWrap .row_${i}`).height(`${maxHeight}px`);
          $(`#${this.tableUniqueId}`).find(`.tableWrap1 .row_${i}`).height(`${maxHeight}px`);
        }
        $(`#${this.tableUniqueId}`).find(`.dataTableMainHeader`).height(`0px`);
        $(`#${this.tableUniqueId}`).find(`.fixedTableHeader`).height(`0px`);
        let maxHHeight = $(`#${this.tableUniqueId}`).find(`.unPinnedSection thead`).height() < $(`#${this.tableUniqueId}`).find(`.pinnedSection thead`).height() ? $(`#${this.tableUniqueId}`).find(`.pinnedSection thead`).height() : $(`#${this.tableUniqueId}`).find(`.unPinnedSection thead`).height();
        $(`#${this.tableUniqueId}`).find(`.dataTableMainHeader`).height(`${maxHHeight}px`);
        $(`#${this.tableUniqueId}`).find(`.fixedTableHeader`).height(`${maxHHeight}px`);
      }, 1)

    },
    initTable(reset) {
      if (reset) {
        this.resetData();
      }
      this.currentSort =
        this.currentSort == "" ? this.defaultSort : this.currentSort;
      this.currentSortDir =
        this.currentSortDir == "" ? this.defaultSortDir : this.currentSortDir;
      if (this.tableData.recordsPerPage != 'All') {
        this.tableData.recordsPerPage = this.getPerPageOptions()[this.paginationDefaultIndex].value;
      }
      /*  if (this.showColumnFilterButton) {
         this.columnFiltersLocal = this.columnFilters;
       } else { */
      this.columnFiltersLocal = false;
      /*  } */
      if (Object.keys(this.localSavedSettingData).length > 0) {
        if (this.localSavedSettingData.visible_fields) {
          this.showFieldsList = JSON.parse(JSON.stringify(this.localSavedSettingData.visible_fields));
        } else {
          this.localFields.map(data => {
            this.showFieldsList.push(data.name);
          });
        }
        if (this.localSavedSettingData.fields) {
          this.localFields = JSON.parse(JSON.stringify(this.localSavedSettingData.fields));
        }

        if (this.localSavedSettingData.currentSort) {
          this.currentSort = this.localSavedSettingData.currentSort;
        }

        if (this.localSavedSettingData.currentSortDir) {
          this.currentSortDir = this.localSavedSettingData.currentSortDir;
        }
        if (this.localSavedSettingData.recordsPerPage) {
          if (this.localSavedSettingData.recordsPerPage != 'All') {
            this.tableData.recordsPerPage = parseInt(this.localSavedSettingData.recordsPerPage);
          } else {
            this.tableData.recordsPerPage = this.localSavedSettingData.recordsPerPage;
          }

        }

      } else {
        this.localFields.map(data => {
          this.showFieldsList.push(data.name);
        });

      }
      this.loadEvents();
      document.addEventListener('click', event => {
        if (!event.target.matches('#viewTableCol, #viewTableCol *') && !event.target.matches('#showColumnFilterBtn, #showColumnFilterBtn *')) {
          this.toggle = false;
        }
        if (!event.target.matches('#searchTable, #searchTable *') && !event.target.matches('#showSearchFilterBtn, #showSearchFilterBtn *')) {
          this.seen = false;
        }
      });
      $(document).ready(() => {
        $('select').formSelect();
        $(`.downloadOptions`).dropdown();
        $(`.columnFilterOptions`).dropdown({ closeOnClick: false });
        /* setTimeout(() => {
          this.resetTableSize();
        }, 20) */
        $(window).on('resize', () => {
          this.resetTableSize();
        });

        /*  $("#viewTableCol").focusout((e) => {
           console.log("comin gasdfasdf", e.target);
           this.toggle = false;
         }); */
      });
    },
    resetData() {
      this.tableData = {
        start: 0,
        end: 0,
        recordsPerPage: 3, //PROJECT_PER_PAGE
        totalRecords: 0 //PROJECT_PER_PAGE
      };
      this.currentSort = "";
      this.currentSortDir = "";
      this.entries = [];
      this.offlineEntries = [];
      this.tempOfflineColumnFilteredEntries = [];
      this.searchText = "";
      this.timeOut = null;
      this.timeOutResize = null;
      this.toggle = false;
      this.seen = false;
      this.showFieldsList = [];
      this.hideFieldsList = [];
      this.allUniques = {};
      this.allUniqueCounts = {};
      this.columnFilterValues = {};
      this.activeColumnFilter = 0;
      this.currentDraggingTable = "";
      this.currentDraggingFromIndex = "";
      this.currentDraggingToIndex = "";
      this.currentDragOverIndex = "";
      this.columnFiltersLocal = false;
      this.columnLocksLocal = false;
      this.showTable = true;
      this.localSavedSettingData = JSON.parse(localStorage.getItem(`local_settings_${this.tableUniqueId}`)) || {};
      this.localFields = this.copyItArray(this.fields);
      this.loadingData = false;
      this.paginationDefaultIndex = 0;
    }
  },
  data() {
    return {
      tableData: {
        start: 0,
        end: 0,
        recordsPerPage: 3, //PROJECT_PER_PAGE
        totalRecords: 0 //PROJECT_PER_PAGE
      },
      currentSort: "",
      currentSortDir: "",
      entries: [],
      offlineEntries: [],
      tempOfflineColumnFilteredEntries: [],
      searchText: "",
      timeOut: null,
      timeOutResize: null,
      toggle: false,
      seen: false,
      showFieldsList: [],
      hideFieldsList: [],
      allUniques: {},
      allUniqueCounts: {},
      columnFilterValues: {},
      activeColumnFilter: 0,
      currentDraggingTable: "",
      currentDraggingFromIndex: "",
      currentDraggingToIndex: "",
      currentDragOverIndex: "",
      columnFiltersLocal: false,
      columnLocksLocal: false,
      showTable: true,
      localSavedSettingData: JSON.parse(localStorage.getItem(`local_settings_${this.tableUniqueId}`)) || {},
      localFields: this.copyItArray(this.fields),
      loadingData: false,
      paginationDefaultIndex: 0,
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pointer {
  cursor: pointer;
  padding: 0px;
}

.actionItems {
  display: inline-block;
  color: #2196f3;
  margin-right: 5px;
}

.actionIcon {
  color: #2196f3;
}

#viewTableCol,
#searchTable {
  width: 300px;
  display: block;
  background: #fff;
  padding: 12px 14px;
  position: absolute;
  z-index: 99;
  text-align: left;
}

#viewTableCol label,
#searchTable label {
  display: block;
  margin-bottom: 4px;
}

.notification {
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.notification .new-count {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 5px 10px;
  border-radius: 50%;
  background: red;
  color: white;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 18px;
  padding: 3px;
}

.noMargin {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.noPadding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.fixedTableHeaderColor {
  background: grey !important;
}

.dataTableMainHeader {
  background: lightgrey;
}

.tableWrap1 {
  overflow: auto;
}

.tableWrap1 table {
  /* min-width: 70px; */
}

.tableWrap {
  overflow: auto;
}

.minorMargin {
  margin-right: 10px
}

/* experiment */


.mainTableWrapperDiv {
  overflow: hidden;
}

.twoColumnTable {
  border-collapse: collapse !important;
}

.unPinnedSection,
.pinnedSection {
  padding-right: 0px;
  padding-left: 0px;
}

.shiftScrollTop {
  margin-top: -17px;
}

.tableHeadWithIcon {
  min-width: 0px;
  width: auto;
}

.filter-dropdown-content {
  min-width: 200px;
  padding: 10px;
}

.active-filter-icon {
  /* background: red; */
  color: white;
  border-radius: 50%;
  padding: 2px;
}

.drag-over {
  background: white;
  border: 3px dashed grey;
  color: lightgrey;
}

.pos-relative {
  position: relative;
}

.right0 {
  right: 0px;
}

.page-nav-prev-next {
  padding-top: 7px;
}

.border-bottom-none {
  border-bottom: none;
}
</style>
